@if (loading()) {
    <div
        class="loading-container flex-content-center"
        [class.loading-container--admin]="adminOpen()"
        [class.loading-container--leaving]="leaving()"
    >
        <img
            class="loading-logo"
            [class.loading-logo--loop]="looping()"
            src="assets/img/v2/logo-sem-fundo-dark.png"
            alt=""
        />
    </div>
}
